import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { FN_SLICE__grid2d_recreate } from '../_methods/FN_SLICE__grid2d_recreate';
import { STATE__grid2d } from '../STATE__grid2d';

export const LOCAL__grid2d_chunk_update_without_cells = (payload: DTO__grid2d_chunk[]): PayloadAction<DTO__grid2d_chunk[]> => ({
  type: ENUM__redux_action.GRID2D_CHUNK_UPDATE_WITHOUT_CELLS,
  payload: payload,
});

export function INIT_LOCAL__grid2d_chunk_update_without_cells(state: STATE__grid2d, action: PayloadAction<DTO__grid2d_chunk[]>) {
  if (action.payload.is_empty()) return;

  for (let grid2d_chunk_update of action.payload) {
    assert_not_null(grid2d_chunk_update._id);
    assert_not_null(grid2d_chunk_update.grid2d_id);

    let grid2d = state.grids2d_map.get(grid2d_chunk_update.grid2d_id);
    try_update_grid2d_chunk_on_grid2d(grid2d, grid2d_chunk_update);

    if (grid2d_chunk_update.are_cells_loaded_first_time) {
      state.grid2d_loading_in_progress.delete(grid2d_chunk_update._id);
      //need to force rerender
      state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
    }
  }

  FN_SLICE__grid2d_recreate(state);
}

function try_update_grid2d_chunk_on_grid2d(grid2d: DTO__grid2d | undefined, grid2d_chunk_update: DTO__grid2d_chunk) {
  if (!grid2d) return; //could be null when user is still not received data during auth

  let grid2d_chunk_index = grid2d.chunks.findIndex(item => item._id == grid2d_chunk_update._id);

  if (grid2d_chunk_index == -1) {
    grid2d.chunk__upsert(grid2d_chunk_update);
  } else {
    let grid2d_chunk = grid2d.chunks[grid2d_chunk_index];
    try_update_grid2d_chunk(grid2d_chunk, grid2d_chunk_update);
    grid2d.chunks[grid2d_chunk_index] = grid2d_chunk;
  }

  grid2d.on_grid2d_updated();
}

function try_update_grid2d_chunk(grid2d_chunk: DTO__grid2d_chunk | undefined, grid2d_chunk_update: Partial<DTO__grid2d_chunk>) {
  if (!grid2d_chunk) return; //could be null when user is still not received data during auth
  if (grid2d_chunk._id != grid2d_chunk_update._id) return;

  for (let key of Object.keys(grid2d_chunk_update)) {
    if (key == DTO__grid2d_chunk.KEY_ARE_CELLS_LOADED_FIRST_TIME) continue;
    if (key == DTO__grid2d_chunk.KEY_CELLS_LIST) continue;

    (grid2d_chunk as any)[key] = (grid2d_chunk_update as any)[key];
  }
}
